import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    padding: [theme.spacing(4), theme.spacing(3), 0],
    backgroundImage: `linear-gradient(180deg, white, ${theme.palette.colors.lightTeal})`,

    [theme.breakpoints.up('mobile')]: {
      padding: ['17vh', theme.spacing(3), 0],
    },
  },
  content: {
    position: 'relative',
    zIndex: 100,
    [theme.breakpoints.up('mobile')]: {
      marginLeft: theme.spacing(8),
    },
  },
  title: {
    color: theme.palette.colors.darkBlue,
    fontSize: 28,
    lineHeight: '124%',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      fontSize: 48,
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: 64,
      lineHeight: '116%',
    },
  },
  subtitle: {
    color: theme.palette.colors.blueGraySecondary,
    fontSize: 16,
    lineHeight: '148%',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('lg')]: {
      fontSize: 24,
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: 32,
      lineHeight: '124%',
      marginBottom: 40,
    },
  },
  select: {
    width: '100%',
    borderRadius: 24,
    marginBottom: 20,
    '& .MuiOutlinedInput-root': {
      borderRadius: 26,
    },
    [theme.breakpoints.up('mobile')]: {
      width: 500,
    },
  },
  button: {
    height: 56,
    width: 180,
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      marginLeft: theme.spacing(2),
      marginTop: 'unset',
      width: 230,
    },
  },
  buttonIcon: {
    fill: theme.palette.colors.white,
  },
  control: {
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
    },
  },
  image: {
    zIndex: 0,
    position: 'absolute',
    width: 'auto',
    maxHeight: '60vh',
    bottom: '-20vh',
    right: '-15vw',
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      width: 'auto',
      maxHeight: 650,
      bottom: 0,
      right: '10vw',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LocationSelect/useStyles.js